// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'https://localhost:44369',
  //apiUrl: 'http://localhost:5000',
  apiUrl: 'https://goldenexpress.azurewebsites.net/',
  instagram_token: 'INSTA_TOKEN',
  //stripe_token: 'pk_test_51MOrRKFv9K5tX55vLWzCGDeMOHRDguE8RnKBcSfqNzcwqu1pfO3qYkmgJWMcVkvmuF2uHYSHfAMYJomT6uOsaSW500vAfvwGIs',
  stripe_token: 'pk_live_51MOrRKFv9K5tX55vsj3lSDbJHfIG6rgYYWruEJQfAzD91UuxjdlwdBCvNIM7oCxpIaSKvbKBQY0XVXijdl8BJWcG00hwYt2SZr',
  paypal_token: 'PAYPAL_TOKEN'
};

//success 4242 4242 4242 4242
// requires auth 4000 0025 0000 3155
//declined 4000 0000 0000 9995
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

//sendgrid 3rYQvmcqw>5H)5a!